// Update only Dark Seer's PDP copy when the theme changes the selected variant.
// The existing variant picker already fetches the new product section HTML.
if (!window.darkseerPdpColorListenerInstalled) {
  window.darkseerPdpColorListenerInstalled = true;

  document.addEventListener('variant:update', (event) => {
    const productId = String(event.detail?.data?.productId ?? '');
    const updatedDocument = event.detail?.data?.html;
    if (!productId || !updatedDocument || event.detail?.data?.newProduct) return;

    const updatedBlocks = [...updatedDocument.querySelectorAll('[data-ds-pdp-product-id]')];
    for (const current of document.querySelectorAll('[data-ds-pdp-product-id]')) {
      if (!current.isConnected || current.dataset.dsPdpProductId !== productId) continue;
      const updated = updatedBlocks.find((candidate) => candidate.id === current.id);
      if (!updated) continue;

      if (current.classList.contains('ds-pdp-accordion')) {
        const currentContent = current.querySelector('.ds-pdp-accordion__item--description .ds-pdp-accordion__content');
        const updatedContent = updated.querySelector('.ds-pdp-accordion__item--description .ds-pdp-accordion__content');
        if (currentContent && updatedContent) currentContent.replaceWith(updatedContent.cloneNode(true));
      } else if (current.classList.contains('ds-pdp-reason')) {
        const currentCopy = current.querySelector('.ds-pdp-reason__copy');
        const updatedCopy = updated.querySelector('.ds-pdp-reason__copy');
        if (currentCopy && updatedCopy) currentCopy.replaceWith(updatedCopy.cloneNode(true));
      }
    }
  });
}

// The quality block lives outside the variant picker section, so update its copy from its color data.
if (!window.darkseerPdpReasonColorListenerInstalled) {
  window.darkseerPdpReasonColorListenerInstalled = true;
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "radio" || !input.name.startsWith("Renk-")) return;
    const picker = input.closest("variant-picker");
    if (!picker || input.dataset.connectedProductUrl) return;
    const block = [...document.querySelectorAll(".ds-pdp-reason[data-ds-pdp-color-content]")].find((item) => item.dataset.dsPdpProductId === picker.dataset.productId);
    if (!block) return;
    let reason;
    try { reason = JSON.parse(block.dataset.dsPdpColorContent || "{}")[input.value]?.reason; } catch { return; }
    if (!reason) return;
    const list = block.querySelector(".ds-pdp-reason__points");
    if (!list) return;
    const intro = list.firstElementChild?.textContent?.trim().startsWith("Işıklı") ? list.firstElementChild.cloneNode(true) : null;
    const sentences = reason.split(". ").map((sentence) => sentence.trim()).filter(Boolean);
    const orthopedic = sentences.filter((sentence) => sentence.toLocaleLowerCase("tr").includes("ortopedik"));
    const quality = sentences.filter((sentence) => !orthopedic.includes(sentence) && /dayan|uzun ömür|kalite|işçilik|iscilik|sağlam|malzeme|taban/i.test(sentence));
    const other = sentences.filter((sentence) => !orthopedic.includes(sentence) && !quality.includes(sentence));
    const visible = Number.parseInt(list.style.getPropertyValue("--ds-pdp-reason-visible-items"), 10) || 2;
    const readMore = block.querySelector(".ds-pdp-reason__read-more");
    list.replaceChildren();
    if (intro) list.append(intro);
    for (const sentence of [...orthopedic, ...quality, ...other]) {
      const item = document.createElement("li");
      if (readMore && list.childElementCount >= visible) item.className = "ds-pdp-reason__point--extra";
      const copy = document.createElement("span");
      copy.textContent = /[.!?]$/.test(sentence) ? sentence : sentence + ".";
      item.append(copy);
      list.append(item);
    }
    if (readMore) readMore.hidden = list.childElementCount <= visible;
  });
}
